import { Carousel, Image, Space } from "antd";
import { FC, useState } from "react";
import {
    LeftOutlined,
    RightOutlined,
    DownloadOutlined,
    SwapOutlined,
    RotateLeftOutlined,
    RotateRightOutlined,
    ZoomOutOutlined,
    ZoomInOutlined,
    UndoOutlined,
} from "@ant-design/icons";

interface PhotoCarouselProps {
    images: string[];
    aspect?: 'square' | "video";
    cover?: boolean;
    imageClasses?: string;
    containerClasses?: string;
}

export const PhotoCarousel: FC<PhotoCarouselProps> = ({
    images,
    aspect = 'video',
    cover,
    imageClasses,
    containerClasses,
}) => {
    const [current, setCurrent] = useState(-1);

    let itemContainerClassName = "w-full box-border text-center";

    if (aspect === 'square') {
        itemContainerClassName += ' aspect-square';
    } else {
        itemContainerClassName += ' aspect-video';
    }

    if (containerClasses) {
        itemContainerClassName += ` ${containerClasses}`;
    }

    let imageClassName = "mx-auto h-full cursor-zoom-in";

    if (cover) {
        imageClassName += " w-full object-cover object-top";
    } else {
        imageClassName += " w-auto object-contain object-center";
    }

    if (imageClasses) {
        imageClassName += ` ${imageClasses}`;
    }

    return (
        <>
            <Carousel
                autoplay
                style={{
                    textAlign: 'center',
                    marginBottom: 24,
                }}
                arrows
                className="rounded-xl overflow-hidden bg-slate-400/90"
            >
                {images.map((i, index) => {
                    return (
                        <div className={itemContainerClassName}>
                            <img key={i} className={imageClassName} src={i} onClick={() => setCurrent(index)} />
                        </div>
                    );
                })}
            </Carousel>
            <Image.PreviewGroup
                items={images}
                preview={{
                    current,
                    visible: current >= 0,
                    toolbarRender: (
                        _,
                        {
                            transform: { scale },
                            actions: {
                                onActive,
                                onFlipY,
                                onFlipX,
                                onRotateLeft,
                                onRotateRight,
                                onZoomOut,
                                onZoomIn,
                                onReset,
                            },
                        },
                    ) => (
                        <Space size={12} className="toolbar-wrapper">
                            <LeftOutlined onClick={() => onActive?.(-1)} />
                            <RightOutlined onClick={() => onActive?.(1)} />
                            {/*<DownloadOutlined onClick={onDownload} />*/}
                            <SwapOutlined rotate={90} onClick={onFlipY} />
                            <SwapOutlined onClick={onFlipX} />
                            <RotateLeftOutlined onClick={onRotateLeft} />
                            <RotateRightOutlined onClick={onRotateRight} />
                            <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
                            <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
                            <UndoOutlined onClick={onReset} />
                        </Space>
                    ),
                    onChange: (index) => {
                        setCurrent(index);
                    },
                    onVisibleChange: (visible, _prevVisible) => {
                        if (!visible) {
                            setCurrent(-1);
                        }
                    }
                }}
            />
        </>
    )
}